import { DropOffPrintIconModel, DropOffPrintIconDto } from '../types/drop-off-print-icon'

export const transformDropOffPrintIcon = (
  dropOffPrintIcon: DropOffPrintIconDto,
): DropOffPrintIconModel => ({
  url: dropOffPrintIcon.url,
  text: dropOffPrintIcon.text,
})
